import http from "@utils/request";

/**
 * 获取历史数据
 */
export const getHistoryData = ( start_time,end_time,sitenolist,medium,order,page=0,size=300) => http({
  method: "POST",
  url: "/bigdata/getHistoryData",
  data: {
    start_time,
    end_time,
    sitenolist,  //站号 SiteNo
    medium,
    order:JSON.stringify(order),
    page,
    size
  },
})
